/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

/**
 * Related to different Housing Assistance types that will behave as "vouchers"
 *
 */
const messages = defineMessages({
  title: {
    id: 'App.HousingAssistanceVouchers.Title',
    defaultMessage: 'Housing Assistance',
  },
  voucherSource: {
    id: 'App.HousingAssistanceVouchers.VoucherSource',
    defaultMessage: 'Source',
  },
  voucherAmount: {
    id: 'App.HousingAssistanceVouchers.VoucherAmount',
    defaultMessage: 'Amount',
  },
  residentRent: {
    id: 'App.HousingAssistanceVouchers.ResidentRent',
    defaultMessage: 'Resident Rent',
  },
  coversRentIncreases: {
    id: 'App.HousingAssistanceVouchers.CoversRentIncreases',
    defaultMessage: 'Covers Rent Increases',
  },
  coversRentIncreasesHelperText: {
    id: 'App.HousingAssistanceVouchers.CoversRentIncreasesHelperText',
    defaultMessage:
      'Indicates whether this voucher will automatically cover any rent increases',
  },
  coversRentIncreasesTooltip: {
    id: 'App.HousingAssistanceVouchers.CoversRentIncreasesTooltip',
    defaultMessage:
      "Turn the toggle on to apply rent increases to assistance; leave it off to apply them only to the resident's share.",
  },
  voucherStartDate: {
    id: 'App.HousingAssistanceVouchers.VoucherStartDate',
    defaultMessage: 'Start Date',
  },
  voucherStartDateError: {
    id: 'App.HousingAssistanceVouchers.StartDateError',
    defaultMessage: 'Must be first day of the month',
  },
  voucherStartDateError2: {
    id: 'App.HousingAssistanceVouchers.StartDateErrorPrior',
    defaultMessage: 'Must be before end date',
  },
  voucherEndDate: {
    id: 'App.HousingAssistanceVouchers.VoucherEndDate',
    defaultMessage: 'End Date',
  },
  voucherEndDateError: {
    id: 'App.HousingAssistanceVouchers.EndDateError',
    defaultMessage: 'Must be last day of the month',
  },
  actions: {
    id: 'App.HousingAssistanceVouchers.Actions',
    defaultMessage: 'Actions',
  },
  addNewVoucher: {
    id: 'App.HousingAssistanceVouchers.AddNewVoucher',
    defaultMessage: 'Add New Assistance',
  },
  editVoucher: {
    id: 'App.HousingAssistanceVouchers.EditVoucher',
    defaultMessage: 'Edit Assistance',
  },
  deleteVoucher: {
    id: 'App.HousingAssistanceVouchers.DeleteVoucher',
    defaultMessage: 'Delete Assistance',
  },
  deleteVoucherConfirmation: {
    id: 'App.HousingAssistanceVouchers.DeleteVoucherConfirmation',
    defaultMessage: 'Are you sure you want to delete this assistance?',
  },
  editVoucherInfo: {
    id: 'App.HousingAssistanceVouchers.EditVoucherInfo',
    defaultMessage:
      'Use <strong>Save</strong> to save assistance details without updating the ledger.</br>' +
      'Use <strong>Save & Post Adjustments</strong> to apply changes to past charges on the ledger.' +
      '\n<em>(Only available for assistance starting in the past.)</em>',
  },
  editVoucherStartDateInfo: {
    id: 'App.HousingAssistanceVouchers.EditVoucher.StartDate.Info',
    defaultMessage:
      'The <strong>Start Date</strong> defaults to the 1st of the selected month. ' +
      'If the selected month is the move-in month, it will match the scheduled move-in date.',
  },
  editVoucherDatesInfoTitle: {
    id: 'App.HousingAssistanceVouchers.EditVoucher.Dates.InfoTitle',
    defaultMessage: 'Dates',
  },
  addNewVoucherDisabledFutureTooltip: {
    id: 'App.HousingAssistanceVouchers.AddNewVoucherDisabledFutureTooltip',
    defaultMessage:
      'You can only schedule one future assistance at a time. ' +
      'Wait for it to start, or change/remove it to schedule another.',
  },
  addNewVoucherDisabledNoMoveInTooltip: {
    id: 'App.HousingAssistanceVouchers.AddNewVoucherDisabledNoMoveInTooltip',
    defaultMessage:
      'You must set and save the scheduled move-in date before adding assistance.',
  },
});

export default messages;
